// Export all tour steps
export * from './buyerDashboardTour';
export * from './sellerDashboardTour';
export * from './buyerPropertySearchTour';
export * from './buyerPropertyDetailTour';
export * from './buyerOffersTour';
export * from './buyerSavedPropertiesTour';
export * from './buyerFavoriteSellersTour';
export * from './buyerNotificationsTour';
export * from './sellerNewPropertyTour';
export * from './sellerActiveDealsTour';
export * from './sellerSearchBuyersTour';
export * from './sellerBuyerListsTour';
export * from './sellerNotificationsTour';
export * from './sellerOffersTour';
export * from './buyerUpgradeTour';
export * from './sellerUpgradeTour';
export * from './buyerProfileTour';
export * from './sellerProfileTour';
export * from './sellerDealTrackerTour';
export * from './buyerRepairEstimatorTour';
export * from './buyerProfitCalculatorTour';

// Tour registry for TourSelector component
export interface TourMetadata {
  id: string;
  name: string;
  path: string;
  description: string;
}

export const tourRegistry: Record<'buyer' | 'seller', TourMetadata[]> = {
  buyer: [
    {
      id: 'buyer_dashboard',
      name: 'Dashboard Tour',
      path: '/buyer/dashboard',
      description: 'Learn the main navigation and key features',
    },
    {
      id: 'buyer_search',
      name: 'Property Search',
      path: '/buyer/search',
      description: 'Find investment properties with powerful filters',
    },
    {
      id: 'buyer_property_detail',
      name: 'Property Details',
      path: '/buyer/search',
      description: 'Evaluate properties and connect with sellers',
    },
    {
      id: 'buyer_offers',
      name: 'My Offers',
      path: '/buyer/offers',
      description: 'Track your offers and their statuses',
    },
    {
      id: 'buyer_saved',
      name: 'Saved Properties',
      path: '/buyer/saved-properties',
      description: 'Manage properties you\'re interested in',
    },
    {
      id: 'buyer_sellers',
      name: 'Favorite Sellers',
      path: '/buyer/favorite-sellers',
      description: 'Follow trusted sellers and see their new listings',
    },
    {
      id: 'buyer_notifications',
      name: 'Notifications',
      path: '/buyer/notifications',
      description: 'Stay updated on new properties and offers',
    },
    {
      id: 'buyer_upgrade',
      name: 'Upgrade Tour',
      path: '/buyer/upgrade',
      description: 'Learn about premium features and how to subscribe',
    },
    {
      id: 'buyer_profile',
      name: 'Profile Management',
      path: '/buyer/profile',
      description: 'Manage your account, preferences, and subscription',
    },
    {
      id: 'buyer_repair_estimator',
      name: 'Repair Estimator',
      path: '/buyer/repair-estimator',
      description: 'Estimate rehab costs with editable line items',
    },
    {
      id: 'buyer_profit_calculator',
      name: 'Profit Calculator',
      path: '/buyer/profit-calculator',
      description: 'Calculate net profit and ROI for a deal',
    },
  ],
  seller: [
    {
      id: 'seller_dashboard',
      name: 'Dashboard Tour',
      path: '/seller/dashboard',
      description: 'Learn the main navigation and key features',
    },
    {
      id: 'seller_deal_tracker',
      name: 'Deal Tracker',
      path: '/seller/deal-tracker',
      description: 'Track deals from agreement to closing',
    },
    {
      id: 'seller_new_property',
      name: 'Upload Property',
      path: '/seller/properties/new',
      description: 'Create compelling property listings',
    },
    {
      id: 'seller_active_deals',
      name: 'Active Deals',
      path: '/seller/properties/active',
      description: 'Manage your listings and track performance',
    },
    {
      id: 'seller_search_buyers',
      name: 'Search Buyers',
      path: '/seller/search-buyers',
      description: 'Find qualified investors for your properties',
    },
    {
      id: 'seller_buyer_lists',
      name: 'Buyer Lists',
      path: '/seller/buyer-lists',
      description: 'Organize buyer contacts into custom lists',
    },
    {
      id: 'seller_notifications',
      name: 'Notifications',
      path: '/seller/notifications',
      description: 'Track buyer interest and activity on your listings',
    },
    {
      id: 'seller_offers',
      name: 'Property Offers',
      path: '/seller/offers',
      description: 'Review and respond to offers on your properties',
    },
    {
      id: 'seller_upgrade',
      name: 'Upgrade Tour',
      path: '/seller/upgrade',
      description: 'Learn about Shark Plan features and how to subscribe',
    },
    {
      id: 'seller_profile',
      name: 'Profile Management',
      path: '/seller/profile',
      description: 'Manage your account, markets, and subscription',
    },
  ],
};
